<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.content">
      <div class="cancelSign" @click="cancelSign(questionData)" v-if="questionData.form&&questionData.form.is_sign == '1'">
        <img src="../../../../assets/cancelSign.png" alt="">
        <span>取消标记</span>
      </div>
      <div class="addSign" @click="addSign(questionData)" v-else>
        <img src="../../../../assets/addSign.png" alt="">
        <span>标记此题</span>
      </div>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">「问答题」<span class="score" v-if="questionData.data.score">{{questionData.data.score}}分</span></div>
         <!-- 试题附件展示组件 -->
        <question-files
          v-if="questionData.data.attachment"
          :attachment="questionData.data.attachment"
        ></question-files>
        <span class="questionName">{{questionData.data.num}}、<span v-html="questionData.data.content"></span>
        </span>
      </div>
      <div class="questionMain">
        <quill-editor class="editor" v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event,questionData)">
        </quill-editor>

        <div class="assessUpload" v-if="questionData.isAssess == '1' || questionData.isAssess == '2'">
          <div class="upload-groups">
            <div id="picker" class="uploadButton" v-show="showFileList.length < 3 ">+ 上传文件</div>
            <div id="upVideo" class="uploadButton" v-show="showFileList.length < 3 ">
              <a-upload :file-list="videoFileList" accept=".mp4" :before-upload="beforeUpload">
                + 上传视频
              </a-upload>
            </div>
          </div>
          <a-button class="disable" type="primary" :disabled="showFileList.length == 3" v-show="showFileList.length==3"> + 上传文件</a-button>
          <a-button class="disable" type="primary" :disabled="showFileList.length == 3" v-show="showFileList.length==3"> + 上传视频</a-button>
          <p class="notice">请注意，您只能上传“.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf、.png、.jpeg、.jpg、.mp3、.mp4”格式，不超过30MB的文件，上传成功后，点击列表名称进行.png、.jpeg、.jpg文件预览，其他格式请下载后查看。</p>
          <a-progress :percent="fileInfo.percentage" v-show="showProgress" />
          <ul class="show" v-if="showFileList.length>0">
            <li v-for="(item,index) in showFileList" :key="index">
              <template v-if="item.type == 'img'">
                <div class="top-box">
                  <img :src="item.preview_url" alt="">
                  <div class="preview" @click="showPreview(item,index)">预览</div>
                  <a class="preview download" @click="uploadFile(item)">下载</a>
                </div>
                <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                <div class="name">{{item.name}}</div>
              </template>
              <template v-else-if="item.type == 'doc'">
                <div class="top-box">
                  <div class="doc">
                    <img src="../../../../assets/word.png" alt="">
                  </div>
                  <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                  <a class="preview" @click="uploadFile(item)">下载</a>
                </div>
                <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                <div class="name">{{item.name}}</div>
              </template>
              <template v-else-if="item.type == 'xls'">
                <div class="top-box">
                  <div class="xls">
                    <img src="../../../../assets/xls.png" alt="">
                  </div>
                  <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                  <a class="preview xls" @click="uploadFile(item)">下载</a>
                </div>
                <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                <div class="name">{{item.name}}</div>
              </template>
              <template v-else-if="item.type == 'ppt'">
                <div class="top-box">
                  <div class="ppt">
                    <img src="../../../../assets/ppt.png" alt="">
                  </div>
                  <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                  <a class="preview" @click="uploadFile(item)">下载</a>
                </div>
                <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                <div class="name">{{item.name}}</div>
              </template>

              <template v-else-if="item.type == 'video'">
                <div class="video">
                  <div class="top-box">
                    <div v-if="item.cover" class="video-cover" :style="`background-image:url('${item.cover}')`"></div>
                    <div v-else class="video-tips">转码中</div>
                    <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                    <a class="preview" @click="uploadVideo(item)">下载</a>
                    <!-- <video :src="item.preview_url"></video> -->
                  </div>
                  <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                  <div class="name">{{item.name}}</div>
                </div>
              </template>

              <template v-else-if="item.type == 'audio'">
                <div class="top-box">
                  <div class="audio">
                    <img class="audio icon" src="../../../../assets/audio.png">
                  </div>
                  <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                  <a class="preview" @click="uploadFile(item)">下载</a>
                </div>
                <img src="../../../../assets/delete.png" alt="" class="delete" @click="DeletePreview(index)">
                <div class="name">{{item.name}}</div>
              </template>

            </li>
          </ul>
          <a-modal class="previewCombina" :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <div class="previewheader">{{dialogName}}</div>
            <template>
              <img :src="previewSrc" v-if="fileType == 'img'">
              <iframe :src="previewSrc" frameborder="0" id="preview" v-else></iframe>
            </template>
          </a-modal>

        </div>

      </div>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{questionData.data.num}}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6';//腾讯云上传视频和转码
import QuestionFiles from "../questionFiles.vue";
import services from '../../../../config/services'
import WebUploader from 'webuploader'//分片上传插件
import { quillEditor } from "vue-quill-editor";
import download from 'downloadjs';
import { Modal } from "ant-design-vue";
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  //["blockquote", "code-block"], // 引用  代码块
  //[{ header: 1 }, { header: 2 }], // 1、2 级标题
  //[{ script: "sub" }, { script: "super" }], // 上标/下标
  //[{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  //[{ size: ["small", false, "large", "huge"] }], // 字体大小
  // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  //[{ font: [] }], // 字体种类
  //[{ align: [] }], // 对齐方式
  //["clean"], // 清除文本格式
  //["link", "image", "video"] // 链接、图片、视频
];
export default {
  name: "quesAnswer",
  props: {
    questionData: {
      type: Object
    },
    /*编辑器的内容*/
    value: {
      type: String
    },
    /*图片大小*/
    maxSize: {
      type: Number,
      default: 4000 //kb
    },
  },
  components: {
    quillEditor,
    QuestionFiles,
  },
  data () {
    return {
      content: this.questionData.form ? this.questionData.form.answer : "",
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        theme: "snow", // or 'bubble'
        placeholder: "请输入你的答案",
        modules: {
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            }
          }
        }
      },
      header: {
        // token: sessionStorage.token
      }, // 有的图片服务器要求请求头需要有token
      value1: this.questionData.form ? this.questionData.form.answer : "",
      showFileList: [],
      videoFileList: [],
      previewVisible: false,
      fileInfo: { // 当前页面上传的文件
        percentage: 0
      },
      status: "", // 上传状态
      previewSrc: "",//预览图片路径
      showProgress: false,//进度条展示
      services: services,
      dialogName: "",// 预览的标题
      fileType: "", // 弹框内容类型
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.filesInitUpload();
      this.initTcVod();
    })
    if(this.questionData.form.attachment){
      this.showFileList = [...this.questionData.form.attachment]
      if (this.showFileList.length > 0) {
        for (let i = 0; i< this.showFileList.length; i++) {
          // status 1 转码中 2转码成功 3转码失败
          let typearr = this.showFileList[i].name.split(".");
          let type = this.judgeType(typearr[typearr.length - 1]);
          this.showFileList[i].type = type
          this.showFileList[i].filename = this.showFileList[i].name
          if(type == 'video'){
            this.showFileList[i].preview_url = this.showFileList[i].file_url
          } else {
            // 其它类型缺少一个 url
            this.showFileList[i].url = this.showFileList[i].file_path;
          }
        }
      }
    } 

  },
  methods: {
    // 腾讯云视频上传初始化
    initTcVod () {
      this.tcVods = new TcVod({
        getSignature: this.getSign
      })
    },
    // 获取腾讯云签名
    async getSign () {
      const { data } = await services.tencentSign();
      return data;
    },
    // 视频上传文件选择后
    beforeUpload(file) {
      this.videoFileList = [...this.videoFileList, file];
      this.videoNextFunc(file);
    },
    videoNextFunc(file) {
      Object.assign(this.fileInfo, {...file}, )
      const isLt5M = file.size < 1024 * 1024 * 30;
      if (!isLt5M) {
        this.$message.error('文件大小不能大于30M');
        return false;
      }
      let that = this;
      const uploaderVideo = that.tcVods.upload({//raw: File  percentage: 0  uid: 1609741194674
        mediaFile: file
      })
      uploaderVideo.on('media_progress', (name, e) => {
        that.showProgress = true;
        that.$set(that.fileInfo, "percentage", parseInt(name.percent * 100));
      })
      uploaderVideo.done().then(doneResult => {
        let newfile = {
          file_id: doneResult.fileId,
          file_url: doneResult.video.url,
          filename: file.name,
          name: file.name,
          type: "video",
          status: 1,
          preview_url: doneResult.video.url,
        }
        that.showFileList.push(newfile);
        that.$set(that.questionData.form, 'attachment', that.showFileList)
        that.showProgress = false;
        that.$set(that.fileInfo, "percentage", 0);
      }).catch(err => {
        that.showProgress = false;
        that.$set(that.fileInfo, "percentage", 0);
      })
    },
    //取消标记
    cancelSign (val) {
      val.form.is_sign = "2";
      this.$forceUpdate()
    },
    //标记此题
    addSign (val) {
      val.form.is_sign = "1";
      this.$forceUpdate()
    },
    onEditorBlur () {
      //失去焦点事件
    },
    onEditorFocus () {
      //获得焦点事件
    },
    onEditorChange (e, val) {
      if(this.questionData.isAssess == '1'){
        if (val.form) { val.form.answer = this.content; }
      } else {
        let str = e.text
        let trimStr = ''
        let reg = /\s+/g;
        if (typeof str === 'string') {
          trimStr = str.replace(reg,'');
        }
        if(trimStr){
          if (val.form) { val.form.answer = this.content; }
        } else {
          if (val.form) { val.form.answer = ''; }
        }
      }
      //内容改变事件
      // if (val.form) { val.form.answer = this.content; }
    },
    handleCancel () {//关闭预览窗口
      this.previewVisible = false;
    },
    // 预览图片
    showPreview (item, index) {//展示预览
      this.dialogName = ""
      this.dialogName = item.type == "img" ? "图片预览" : item.type == "doc" ? "文档预览" : item.type == "xls" ? "Excel预览" : item.type == "ppt" ? "PPT预览" : item.type == "video" ? "视频预览" : item.type == "audio" ? "音频预览" : ""
      this.fileType = item.type
      if (item.pdf_path) {
        this.previewSrc = item.pdf_path;
        this.previewVisible = true;
      } else {
        this.previewSrc = item.preview_url
        this.previewVisible = true
      }
    },
    // 下载视频方法
    uploadVideo(item){
      fetch(item.preview_url).then(res => res.blob()).then(blob => {
        let newUrl = window.URL.createObjectURL(blob)
        this.createUrlBlob(newUrl, item.filename)
      })
    },
    // 文件流统一处理
    createUrlBlob (url, fileName) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', fileName);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 下载文件方法
    uploadFile (item) {
      let params = {
        is_download: 1, // 1下载2预览
      }
      if(item.id){
        params.id = item.id
      } else {
        params.path = item.url
        params.name = item.filename
      }
      services.attachmentFileGet(params).then((res) => {
        // let fileName = item.name.substring(0, item.name.lastIndexOf("."));
        // let format = item.name.substring(item.name.lastIndexOf("."));
        download(res, item.filename, "text/plain");
      })
    },
    //删除附件文件
    DeletePreview (index) {
      let that = this
      Modal.confirm({
				title: '确定删除该文件吗？',
				okText: '确定',
				cancelText: '取消',
				onOk() {
          that.showFileList.splice(index, 1);
          if (that.showFileList.length > 0) {
            that.$set(that.questionData.form, 'attachment', [...that.showFileList])
          } else {
            that.$set(that.questionData.form, 'attachment', [])
          }
				},
				onCancel() {
					// console.log('Cancel');
				},
			})
    },
    // 文件后缀名分类方法
    judgeType (name) {
      let imgList = ["png", "jpeg", "jpg"];
      let doclist = ["doc", "docx"];
      let xlsList = ["xls", "xlsx"];
      let pptList = ["ppt", "pptx", "pdf"];
      let videoList = ["mp4"]
      let audioList = ["mp3"]
      if (imgList.indexOf(name) != (-1)) {
        return "img";
      } else if (doclist.indexOf(name) != (-1)) {
        return "doc";
      } else if (xlsList.indexOf(name) != (-1)) {
        return "xls";
      } else if (pptList.indexOf(name) != (-1)) {
        return "ppt";
      } else if (videoList.indexOf(name) != (-1)) {
        return "video";
      } else if (audioList.indexOf(name) != (-1)) {
        return "audio";
      }
    },
    // 上传文件初始化方法
    filesInitUpload () {
      let serverUrl = "";
      if (process.env.NODE_ENV === "production") {
        serverUrl = `${services.XUEXI_SERVER}/api/upload/file`;
      } else {
        serverUrl = `${services.XUEXI_SERVER}/api/upload/file`;
      }
      let that = this;
      let uploader = WebUploader.create({
        swf: "@/assets/Uploader.swf", // swf文件路径
        withCredentials: true, // 跨域携带cookie
        server: serverUrl, // 文件接收服务端。
        accept: {
          // 指定接受哪些类型的文件
          extensions: "doc,docx,xls,xlsx,ppt,pptx,pdf,png,jpeg,jpg,mp3", //允许的文件后缀，不带点，多个用逗号分割。
          mimeTypes: ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpeg,.jpg,.mp3", //多个用逗号分割。
        },
        defaultSucMsg: true,
        method: "POST", //请求方式
        fileNumLimit: 3, //验证文件总数量, 超出则不允许加入队列
        fileSingleSizeLimit: 1024 * 1024 * 30, //验证单个文件大小是否超出限制
        chunkRetry: 10, // 如果某个分片由于网络问题出错，允许自动重传多少次？
        pick: {
          id: "#picker",
          multiple: false, // 是否开起同时选择多个文件能力
        },
        fileVal: 'filename',
        auto: true, //是否开启自动上传
        chunked: true, //是否要分片处理大文件上传。
        chunkSize: 1024 * 1024 * 3, //  [默认值：5242880] 如果要分片，分多大一片？ 默认大小为5M.
        // duplicate: false, // 去重， 根据文件名字、文件大小和最后修改时间来生成hash Key
        resize: false//是否压缩
      });
      uploader.on("uploadBeforeSend", function (obj, data) {
        data.is_tmp = true
        data.act = 'upload'
        data.resource_type = (that.questionData.isAssess == '2' ? 'tk_exam' : 'tk_user')
        data.chunk = obj.chunk
        data.chunks = obj.chunks
        that.$set(that.fileInfo, "chunks", obj.chunks);
        // 删除其他数据(默认的上传字段)
        delete data.lastModifiedDate;
        delete data.id;    
        delete data.type;  
        delete data.size;  
      });
      uploader.on("beforeFileQueued", function () {
        that.showProgress = true;
      });
      // 当有文件被添加进队列的时候
      uploader.on("fileQueued", function (file) {
        Object.assign(that.fileInfo, { ...file, percentage: 0 });
        uploader.upload();
      });
      //进度条
      uploader.on("uploadProgress", function (file, percentage) {
        that.status = "percentage";
        that.$set(that.fileInfo, "percentage", parseInt(percentage * 100));
      });
      uploader.on("uploadSuccess", async function (file, response) {
        let resdata = ''
        if(that.fileInfo.chunks > 1){
          resdata = await services.fileUpload({
            act: 'merge',
            name: file.name,
            chunks: that.fileInfo.chunks,
            is_tmp: true,
            is_thumb:false,
            is_compress: false,
            resource_type: (that.questionData.isAssess == '2' ? 'tk_exam' : 'tk_user'),
          });
        }
        
        if((that.fileInfo.chunks > 1 && resdata.code == '0000') || (that.fileInfo.chunks == 1 && response.code == '0000')){  
          let obj = {
            que_id: that.questionData.form.que_id,
            haveFile: true
          }
          that.showProgress = false;
          that.$set(that.fileInfo, "percentage", 0);
          let alldata = that.fileInfo.chunks > 1 ? resdata.data : response.data
          that.fileInfo = Object.assign(that.fileInfo, { ...alldata });
          let newFile = alldata
          newFile.type = that.judgeType(file.ext)
          newFile.name = file.name
          that.showFileList.push(newFile);
          that.$set(that.questionData.form, 'attachment', that.showFileList)
          that.status = "success";
          if (!that.content && that.questionData.isAssess == '1') {
            that.content = "<p> </p>"
          }
        }
      });
      uploader.on("uploadError", function (file, reason) {
        that.$message.error("上传失败");
        that.status = "error";
      });
      uploader.on("uploadComplete", function () {
        uploader.reset();
      });
      uploader.on("error", function (type) {
        that.showProgress = false;
        that.$set(that.fileInfo, "percentage", 0);
        if (type == "F_EXCEED_SIZE") {
          that.$message.error("上传文件大小不能超过30MB");
        } else if (type == "Q_TYPE_DENIED") {
          that.$message.error("文件必须为.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf、.png、.jpeg、.jpg、.mp3、.mp4类型");
        } else {
          that.$message.error("上传失败");
        }
        that.status = "error";
      });
    },
  }

}
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  position: absolute;
  top: 35px;
  right: 50px;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.cancelSign {
  float: right;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.cancelSign span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f79e3f;
  line-height: 32px;
}
.addSign {
  float: right;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.addSign span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 32px;
}
.question .title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  width: 100%;
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
  /deep/ol {
    list-style: decimal;
    margin-left: 15px;
  }
}
.questionMain {
  width: 100%;
  position: relative;
}
.questionMain img {
  width: 100%;
  height: 200px;
}
.questionMain .quill-editor {
  height: 245px;
  margin-top: 10px;
}
li {
  margin-bottom: 20px;
}
ul {
  margin-top: 10px;
}
li .textarea {
  width: 85%;
}
li span {
  line-height: 32px;
}
/deep/p:first-child {
  display: inline;
}
.avatar-uploader {
  display: none;
}
.question /deep/ol {
  list-style: decimal;
  margin-left: 15px;
}
.score {
  color: #9a3bec;
  font-weight: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
.upload-groups {
  .uploadButton {
    /deep/ .ant-upload {
      color: #2462f5 !important;
      width: 100% !important;
    }
    /deep/ .ant-upload-list {
      display:  none;
    }
  }
}
.uploadButton {
  border-radius: 10px;
  height: 30px;
  line-height: 30px;
  margin-right: 20px;
  width: 100px;
  display: inline-block;
  border: 1px solid #2462f5;
  color: #2462f5 !important;
  text-align: center;
  margin-top: 20px;
}
.uploadButton:hover {
  background: #dbe6fd;
  border: none;
}
.notice {
  color: #b0b2b8;
  font-size: 12px;
  margin-top: 10px;
  bottom: 170px;
}
.show {
  margin-top: 0px;
  display: flex;
  padding-top: 20px;
  li {
    width: 240px;
    margin-right: 25px;
    position: relative;
    .top-box {
      width: 240px;
      height: 135px;
      position: relative;
    }
    .doc,
    .xls,
    .ppt,
    video {
      background: #e5ecfb;
      width: 240px;
      height: 135px;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      img {
        width: auto;
        height: auto;
      }
    }
    .video {
      .video-tips {
        width: 240px;
        height: 135px;
        line-height: 135px;
        text-align: center;
        background: #e5ecfb;
        color: #b0b2b8;
        // color: #666666;
      }
      .video-cover {
        width: 240px;
        height: 135px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .audio {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eee9ff;

      width: 240px;
      height: 135px;
      .audio.icon {
        width: auto;
        height: auto;
      }
    }
    .ppt {
      background: #ffebea;
    }
    .xls {
      background: #ddffeb;
    }
    img {
      width: 240px;
      height: 135px;
    }
    .preview {
      width: 60px;
      height: 30px;
      line-height: 30px;
      background: #2462f5;
      color: #ffffff;
      border-radius: 15px;
      text-align: center;
      position: absolute;
      left: 5px;
      bottom: 5px;
      font-size: 12px;
      z-index: 9;
      cursor: pointer;
    }
    .preview.download.xls {
      left: 5px;
    }
    .preview.download {
      left: 75px;
    }
    .delete {
      position: absolute;
      width: 26px;
      height: 26px;
      top: -13px;
      right: -13px;
    }
    .name {
      text-align: center;
      color: #666666;
      font-size: 12px;
      margin-top: 10px;
      word-break: break-all;
      height: auto;
      width: 240px;
    }
  }
}

.disable {
  height: 30px;
  width: 100px;
  border-radius: 40px;
  margin-top: 20px;
  margin-right: 20px;
  display: inline-block;
}
.assessUpload {
  /deep/.webuploader-element-invisible {
    display: none;
  }
  /deep/.webuploader-pick + div {
    width: 100px !important;
  }
}

/deep/.anticon {
  vertical-align: 0.8rem;
}

.previewCombina {
  img {
    margin: 10px;
    max-width: 70%;
  }
  /deep/ .ant-modal {
    width: 85vw !important;
    height: 85vh !important;
  }

  /deep/ .ant-modal-body {
    text-align: center !important;
    padding: 0 !important;
    width: 85vw !important;
    height: 80vh !important;
    audio,
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 500px;
    }
  }
  /deep/.ant-modal-close-x {
    width: 30px;
    height: 30px;
    line-height: 70px !important;
  }
  iframe {
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      max-width: 95%;
      max-height: 95%;
    }
  }
}
.previewheader {
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  text-align: left;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: 700;
  background-color: #e5ecfb;
}
/deep/.ant-modal-body img {
  max-width: 75%;
}
</style>